/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-indent */
import React from 'react';
import { FooterActionsEnum } from '../../interface';
import { ReactComponent as RemoveAud } from '../../../../assets/img/remove-aud-list.svg';
import { ReactComponent as Add } from '../../../../assets/img/add-aud-list.svg';
import { ReactComponent as CheckMark } from '../../../../assets/img/icons/CheckMark.svg';

interface GlobalActionsProps {
    clickHandle: (type: string) => void;
    isListContact: boolean;
}

interface ListActionsProps {
    clickHandle: (type: string) => void;
}

type Props = {
    isGlobal?: boolean;
    isListContact?: boolean;
    clickHandle: (type: string) => void;
} & typeof defaultProps;

const defaultProps = {
    isGlobal: false,
    isListContact: false,
};

const GlobalActions = (globalActionProps: GlobalActionsProps) => {
    const { isListContact, clickHandle } = globalActionProps;
    if (isListContact) return <div className="aud-action disabled mr-2"><CheckMark /></div>;
    return (
        <div className="aud-action mr-1" onClick={(e) => { clickHandle(FooterActionsEnum.ADD_TO_LIST); e.stopPropagation(); }}>
            <Add />
        </div>
    );
};

const ListActions = (listActionsProps: ListActionsProps) => {
    const { clickHandle } = listActionsProps;
    return (
        <div className="aud-action" onClick={(e) => { clickHandle(FooterActionsEnum.REMOVE_FROM_LIST); e.stopPropagation(); }}>
            <RemoveAud />
        </div>
    );
};

const ContactsTableAddRemove = (props: Props) => {
    const { isGlobal, isListContact, clickHandle } = props;

    return (
        isGlobal ? <GlobalActions isListContact={isListContact} clickHandle={clickHandle} /> : <ListActions clickHandle={clickHandle} />
    );
};

ContactsTableAddRemove.defaultProps = defaultProps;

export default ContactsTableAddRemove;
